export enum AnnouncementBaubleTypeEnum{
    Blue = 1,
    Green = 2,
    SnowFlake = 3,
    SantaHat = 4,
    Tree = 5,
    Snowman = 6,
    Red = 7
}